const DEFAULT_WARNING_TIMEOUT_MS = 10 * 60 * 1000;
const DEFAULT_LOGOUT_TIMEOUT_MS = 15 * 60 * 1000;

declare global {
  interface Window {
    inactivityConfig?: {
      warningTimeoutMs?: number;
      logoutTimeoutMs?: number;
      forceEnabled?: boolean;
    };
  }
}

/**
 * Get warning timeout, checking for Playwright test override first
 */
export function getWarningTimeoutMs(): number {
  if (
    typeof window !== 'undefined' &&
    window.inactivityConfig?.warningTimeoutMs
  ) {
    return window.inactivityConfig.warningTimeoutMs;
  }

  return DEFAULT_WARNING_TIMEOUT_MS;
}

/**
 * Get logout timeout, checking for Playwright test override first
 */
export function getLogoutTimeoutMs(): number {
  if (
    typeof window !== 'undefined' &&
    window.inactivityConfig?.logoutTimeoutMs
  ) {
    return window.inactivityConfig.logoutTimeoutMs;
  }

  return DEFAULT_LOGOUT_TIMEOUT_MS;
}

/**
 * Check if inactivity detection should be force-enabled (for Playwright tests)
 * This bypasses the authentication check when testing
 */
export function isForceEnabled(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.inactivityConfig?.forceEnabled === true
  );
}

export const INACTIVITY_CONFIG = {
  get WARNING_TIMEOUT_MS() {
    return getWarningTimeoutMs();
  },
  get LOGOUT_TIMEOUT_MS() {
    return getLogoutTimeoutMs();
  },
  BROADCAST_CHANNEL_NAME: 'inactivity-detection',
  LAST_ACTIVITY_KEY: 'last-activity-timestamp',
  ACTIVITY_EVENTS: [
    'mousedown',
    'keydown',
    'touchstart',
    'scroll',
    'pointermove',
  ] as const,
  COUNTDOWN_INTERVAL_MS: 1000,
  ACTIVITY_DEBOUNCE_MS: 100,
} as const;
